import React, { useEffect, useState, useRef } from "react";
import APIUrls from "../../../services/APIUrls";
import { dateFormat } from "../../../services/Util";
import { getAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import Constants from "../../../Constants";
import { Link } from "react-router-dom";
import FilterProject from "../../dashboard/FilterProject";
import { useSelector } from "react-redux";
import $ from "jquery";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import DateFormat from "../../../pages/DateFormat";
export default function AddExistingProjectToCampaign(prop) {
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const workspaceId = prop.workspaceId;
  const [projectDataLoader, toggleLoader] = useState(true);
  const [perPage, setPerPage] = useState(5);
  const [sort, setSort] = useState("");
  const [data, updateList] = useState([]);
  const [currentPage, updateCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [sortFocus, setsortFocus] = useState('');
  const [searchText, setSearchText] = useState('');
  const paginationRef = useRef();
  
  const { t } = useTranslation();
  const translate = t;
  
  const SelectDepartMentRedux = useSelector(
    (departmentSelected) => departmentSelected.select_dropdown
  ).value;
  var departmentId =
  SelectDepartMentRedux !== ""
    ? `&userGroupIds=${SelectDepartMentRedux}`
    : "";
  const SelectProjectStatusRedux = useSelector(
    (projectStatusSelected) =>
      projectStatusSelected.project_status
  );
  const followed = useSelector((FollowingSlice) => FollowingSlice.follow).value;
  const searchRedux = useSelector(
    (projectListSearch) => projectListSearch.project_list_search
  ).value;

  const searchParameter = searchRedux !== "" ? `&projectName=${searchRedux}` : searchText !== "" ? `&projectName=${searchText}` : "";

  const handleRowSelected = (rows) => {
            prop.func(rows);
    };
  const handlePerRowsChange = async (newPerPage, page) => {
    await getAxiosResponse(
      APIUrls.PROJECT_LIST +
        `?workspaceId=${workspaceId}&excludeWorkspaceProjects=true&onlyFollowed=${followed}&page=${page}&pageSize=${newPerPage}${sort}${SelectProjectStatusRedux.value}${departmentId}${searchParameter}`
    )
      .then((res) => {
        if (res.data !== "") {
          updateList(res.data.data.result);
          setPerPage(newPerPage);
          setTimeout(function(){
            $('.datatable-block nav.rdt_Pagination select').trigger('focus');
          }, 100);
        }
      })
    toggleLoader(false);
  };
  const handlePageChange = (paging) => {
    toggleLoader(true);
    updateCurrentPage(paging);
    // updatePrevPage(currentPage);
    if ($('#pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-previous-page').attr('id');
    } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
    .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
    var order = sortDirection.toUpperCase();
    var sortedColumn = column.id;
    var sortedString = `&sortOrder=${order}&sortColumn=${sortedColumn}`;
    setSort(sortedString);
    setsortFocus(column.id);
  };
  const fetchProjectData =  (page) => {
     getAxiosResponse(
      APIUrls.PROJECT_LIST +
        `?workspaceId=${workspaceId}&excludeWorkspaceProjects=true&onlyFollowed=${followed}&page=${page}&pageSize=${perPage}${sort}${SelectProjectStatusRedux.value}${departmentId}${searchParameter}`
    )
      .then((res) => {
        if (res.data !== "") {
          updateList(res.data.data.result);
          setTotalRows(res.data.data.resultCount);
          setTimeout(() => {
            if(sortFocus){
              $(".rdt_TableCol_Sortable[data-column-id='" + sortFocus + "']").trigger('focus');
              setsortFocus('');
            }
            else if (paginationRef.current) {
                $('#'+ paginationRef.current).trigger('focus');
                paginationRef.current = '';
            }
              $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
              $(".rdt_Table").attr("aria-label","campaign projects"); 
          }, 300);
        }
      })
    toggleLoader(false);
  };
  useEffect(() => {

    fetchProjectData(currentPage);
  }, [ SelectProjectStatusRedux,SelectDepartMentRedux, currentPage,sort,searchParameter,followed]);

  useEffect(() => {
    setTimeout(() => {
      $('#ExistingProjectclosebtn').trigger('focus');
    }, 500);
  }, []);
  useEffect(()=>{
    setTimeout(()=>{
      $("#filterBtn").addClass("show-flex" );
    },1000)
  });
  const columns = [
    {
      id: "project.name",
      name: "Project Name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.name}>
          <Link
            style={{
              color: aaaSelected ? "#FFF" : "#4067D6",
              fontWeight: 500,
              position: "relative",
            }}
            to={`/project/${row?.id}`}
          >
            {row.name}
          </Link>
        </div>
      ),
    },
    {
      id: "project.owner",
      name: "Owner",
      selector: (row) => row.owner,
      sortable: true,
      cell: (row) => (
        <div
          aria-label={row.owner.firstName + " " + row.owner.lastName}
        >
          {row.owner.firstName + " " + row.owner.lastName}
        </div>
      ),
    },
    {
      id: "project.userGroup",
      name: "Department",
      selector: (row) => row.userGroup,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.userGroup.name}>
          {row.userGroup.name}
        </div>
      ),
    },
    {
      id: "project.projectContentType",
      name: "Content Source",
      selector: (row) => row.projectContentTypeDisplay,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.projectContentTypeDisplay}>
          {row.projectContentTypeDisplay}
        </div>
      ),
    },
    {
      id: "projectQueryResult.vendor_name",
      name: "Vendors",
      selector: (row) => row.vendor.name,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.vendor.name}>
          {row.vendor.name}
        </div>
      ),
    },
    {
      id: "project.status",
      name: "Status",
      selector: (row) => row.status.display,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.status.display}>
          {translate(row?.status?.display)}
          </div>
      ),
    },
    {
      id: "projectQueryResult.dueDate",
      name: "Due Date",
      selector: (row) => row.dueDate,
      sortable: true,
      cell: (row) => (
        <div>
          <DateFormat date={row.dueDate} />
        </div>
      ),
    },
  ];
  return (
    <div className="" style={{ width: "100%" }}>
      <FilterProject filter="campaign" setSearchText={setSearchText} searchText={searchText}/>
      <div id="add_existing_project" className="datatable-block">
        <DataTable
          keyField="id"
          columns={columns}
          data={data}
          selectableRows
          defaultSortFieldId={1}
          responsive
          striped
          selectableRowsHighlight={true}
          onSelectedRowsChange={handleRowSelected}
          pagination
          onSort={handleSort}
          pointerOnHover={true}
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5,10, 20, 40, 50, 100, 200]}
          onChangePage={handlePageChange}
          progressPending={projectDataLoader}
          noDataComponent="No data found"
          fixedHeader="true"
          fixedHeaderScrollHeight="500px"
        />
      </div>
    </div>
  );
}
